import { render, staticRenderFns } from "./exchangerateMaintain.vue?vue&type=template&id=4e32e765&scoped=true"
import script from "./exchangerateMaintain.vue?vue&type=script&lang=js"
export * from "./exchangerateMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32e765",
  null
  
)

export default component.exports